/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S13_I2Inputs */

const tr_kullanim_s13_i2 = /** @type {(inputs: Kullanim_S13_I2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şirket, Sözleşme'nin esaslı ihlali halinde veya Kullanıcı'nın 3 ay süreyle pasif kalması durumunda tek taraflı fesih hakkını saklı tutar.`)
};

const en_kullanim_s13_i2 = /** @type {(inputs: Kullanim_S13_I2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Company reserves the right of unilateral termination in the event of a material breach of the Agreement or if the User remains inactive for 3 months.`)
};

const de_kullanim_s13_i2 = /** @type {(inputs: Kullanim_S13_I2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Unternehmen behält sich das Recht zur einseitigen Kündigung vor, wenn der Vertrag wesentlich verletzt wird oder der Nutzer 3 Monate lang inaktiv bleibt.`)
};

const ru_kullanim_s13_i2 = /** @type {(inputs: Kullanim_S13_I2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Компания оставляет за собой право одностороннего расторжения в случае существенного нарушения Договора или если Пользователь остаётся неактивным в течение 3 месяцев.`)
};

/**
* | output |
* | --- |
* | "The Company reserves the right of unilateral termination in the event of a material breach of the Agreement or if the User remains inactive for 3 months." |
*
* @param {Kullanim_S13_I2Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s13_i2 = /** @type {((inputs?: Kullanim_S13_I2Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S13_I2Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s13_i2(inputs)
	if (locale === "de") return de_kullanim_s13_i2(inputs)
	if (locale === "ru") return ru_kullanim_s13_i2(inputs)
	return tr_kullanim_s13_i2(inputs)
});